import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductReceiveDialogComponent } from './product-receive-dialog.component';


const routes: Routes = [
  {
    path: '',
    component: ProductReceiveDialogComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductReceiveDialogRoutingModule { }
